module.exports = __webpack_public_path__ + "static/media/Card_shuffle.d5fc5a1f.mp3";